<template>
  <div v-if="reminder" class="section is-small">
    <ModalEditMailText
      v-if="showEditMailText"
      :showModal="showEditMailText"
      :onClickCancel="hideModal"
      :mailText="selectedMailText"
      @mailTextUpdated="updateMailText"
    />
    
    <div class="container">
      <ui-section-header
        :showEdit="true"
        :editFunction="setShowData"
      >
        <template v-slot:title>Basic data</template>
      </ui-section-header>
      
      <table class="table is-fullwidth">
        <tbody>
          <tr>
            <td>Name</td>
            <td>{{ reminder.Name }}</td>
          </tr>
          <tr>
            <td>Days</td>
            <td>{{ reminder.Days }}</td>
          </tr>
          <tr>
            <td>Meetingtype</td>
            <td>{{ reminder.MeetingType }}</td>
          </tr>
          <tr>
            <td>Sender address</td>
            <td>{{ reminder.SenderAddress }}</td>
          </tr>
        </tbody>
      </table>

      <ui-section-header
        :showAdd="true"
        :addFunction="setShowAddLanguage"
      >
        <template v-slot:title>Mail text</template>
      </ui-section-header>

      <div class="columns">
        <div
          v-for="(text, index) in reminder.Texts"
          :key="index"
          class="column"
        >
          <div class="level">
            <div class="level-left">
              <div class="subtitle">{{ $t('LanguageLabels.Language' + text.LanguageId) }}</div>
            </div>
            <div class="level-right">
              <a
                @click="setShowEditText(text)"
                class="has-icon has-margin-left"
              >
                <span class="icon">
                  <font-awesome-icon :icon="['fa', 'edit']" />
                </span>
                <span>Edit</span>
              </a>
            </div>
          </div>

          <div class="textWrapper">
            <strong>Subject:</strong><br />
            {{ text.Subject }}

            <div class="is-divider"></div>

            <strong>Body:</strong><br />
            <div
              class="content"
              v-html="text.Body"
            ></div>
          </div>
        </div>http://localhost:8081/1/configuration
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { EventBus } from '@/eventbus/event-bus'
import { mapState } from 'vuex'
import mailProvider from '@/providers/mail'

export default {
  components: {
    ModalEditMailText: () => import('@/components/Settings/ModalEditMailText'),
  },

  props: {},

  data() {
    return {
      isLoading: false,
      languages: [],
      reminderId: this.$route.params.reminderId ? Number(this.$route.params.reminderId) : 0,
      reminder: null,
      selectedMailText: null,
      showEditMailText: false,
    }
  },

  computed: {
    ...mapState('channelStore', ['channel']),

    unusedLanguages() {
      let languages = [];

      if (this.reminder && this.reminder.Languages) {
        for(let i = 0; i < this.languages.length; i++) {
          const language = this.languages[i];
          let index = this.reminder.Languages.findIndex(l => l.Id === language.Id);
          if (index === -1) {
            languages.push({
              Id: language.Id,
              Name: language.Name,
              ISO2: language.ISO2
            });
          }
        }
      }

      return languages;
    },
  },

  created() {
    this.languages.push({ Id: 52, Name: 'Dutch', ISO2: 'nl' });
    this.languages.push({ Id: 65, Name: 'English', ISO2: 'en'  });
    this.languages.push({ Id: 86, Name: 'German', ISO2: 'de'  });
    this.languages.push({ Id: 75, Name: 'French', ISO2: 'fr'  });
    this.languages.push({ Id: 156, Name: 'Spanish', ISO2: 'es'  });
    this.languages.push({ Id: 106, Name: 'Italian', ISO2: 'it'  });

    this.getReminder();
  },

  methods: {
    getReminder() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      mailProvider.methods
        .getReminderMailById(this.reminderId)
        .then((response) => {
          if (response.status === 200) {
            this.reminder = response.data;
          }
        })
        .finally(() => {
          this.isLoading = false;
        })
    },

    setShowData() {

    },

    setShowAddLanguage() {

    },

    setShowEditText(text) {
      this.showEditMailText = true
      this.selectedMailText = text
    },

    hideModal() {
      this.showEditMailText = null
      this.showEditMailText = false
    },

    updateMailText(mailText) {
      mailProvider.methods
        .saveReminderMailtext(this.reminder.Id, mailText)
        .then((response) => {
          if (response.status === 200) {
            this.$emit('mailTextUpdated', response.data)

            EventBus.$emit('showToast', {
              type: 'info',
              message: 'Text saved!',
            });

            this.hideModal();
          }
        })
        .catch((e) => {
        })
        .finally(() => {
        })

      let index = this.reminder.Texts.findIndex((mt) => mt.Id === mailText.Id)
      if (index > -1) {
        Vue.set(this.reminder.Texts, index, mailText)
      }
    },
  },
}
</script>

<style></style>
